import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TagInputModule } from 'ngx-chips';
import { LoaderComponent } from './components/loader/loader.component';

TagInputModule.withDefaults({
    tagInput: {
        placeholder: 'Přidat nový štítek',
        secondaryPlaceholder: '+ přidat štítek',
    },
    dropdown: {
        showDropdownIfEmpty: true,
        keepOpen: false,
        focusFirstElement: true,
        minimumTextLength: 1,
        limitItemsTo: 20,
        zIndex: 100000,
    },
});

@NgModule({
    declarations: [LoaderComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    exports: [CommonModule, FormsModule, LoaderComponent, ReactiveFormsModule],
})
export class SharedFeaturesModule {}
